<template>
  <div class="modelReg">
    <div class="modelReg__grid">
      <div class="modelReg__title">
        <h3>{{ $t('modal.auth_modal_state.set_password.title') }}</h3>
      </div>
      <div class="modelReg__alertLoading" v-if="loader"></div>
      <div class="modelReg__alertError" v-if="errorMessage">{{ errorMessage }}</div>
      <div class="modelReg__alertSuccess" v-if="successMessage">{{ successMessage }}</div>

      <UForm class="modelReg__form">
        <UiBaseInputN
          v-model="form.password"
          :type-input="'password'"
          :label="$t('modal.auth_modal_state.set_password.input_password')"
          :placeholder="$t('modal.auth_modal_state.set_password.inputPassword')"
          :error="v$.password.$error"
          :errors="v$.password.$errors"
          :show-error="false"
          @change="v$.password.$touch"
        ></UiBaseInputN>

        <!-- Визуальная шкала силы пароля -->
        <PasswordStrengthMeter :password="form.password" :show-suggestions="false" />

        <!-- Требования к паролю -->
        <PasswordRequirementsList :validation="v$.password" />

        <UiBaseInputN
          v-model="form.confirmPassword"
          :type-input="'password'"
          :label="$t('modal.auth_modal_state.set_password.input_confirm_password')"
          :placeholder="$t('modal.auth_modal_state.set_password.input_confirm_password')"
          :error="v$.confirmPassword.$error"
          :errors="v$.confirmPassword.$errors"
          :show-error="true"
          @change="v$.confirmPassword.$touch"
        ></UiBaseInputN>

        <UiButtonMain
          class="btn"
          size="xl"
          :label="$t('modal.auth_modal_state.set_password.btn')"
          block
          type="submit"
          :disabled="v$.$invalid"
          @click.prevent="sendSetPassword"
        ></UiButtonMain>
      </UForm>
    </div>
  </div>
</template>

<script setup>
/* v8 ignore file */
import { useVuelidate } from '@vuelidate/core';

import { modalStateEnum } from '@shared/model';
import apiAuthInstance from '~/entities/auth';
import { useModalStore } from '@shared/model';
import { useRulesForForm } from '@shared/lib';

const storeModal = useModalStore();

const props = defineProps({
  userData: {
    type: Object,
    required: true,
    default: () => ({
      email: '',
      password: '',
      confirmPassword: '',
      oldPassword: '',
      twoFA: '',
      codeFromEmail: '',
    }),
  },
});
const form = ref({ ...props.userData });
const loader = ref(false);
const errorMessage = ref(null);
const successMessage = ref(null);

const { RulesForFormConfirmPassword, RulesForFormNewPassword } = useRulesForForm();

const rules = computed(() => {
  return {
    password: RulesForFormNewPassword(form.value),
    confirmPassword: RulesForFormConfirmPassword(form.value.password),
  };
});
const openModalRestorePassword = () => {
  storeModal.state(modalStateEnum.RestorePassword);
};
const v$ = useVuelidate(rules, form);

const sendSetPassword = () => {

  const params = {
    password: form.value.password,
  };
  v$.value.$validate();
  if (!v$.value.$error) {
    loader.value = true;
    apiAuthInstance
      .setPassword(params)
      .then((data) => {

         successMessage.value = data.message;
        setTimeout(() => {
          storeModal.close();
        }, 2000);
      })
      .catch((error) => {
         errorMessage.value = 'Сервер не отвечает';
      })
      .finally(() => {
         loader.value = false;

        setTimeout(() => {
          errorMessage.value = null;
          successMessage.value = null;
        }, 6000);
      });
  }
};
</script>

<style scoped lang="scss">
.modelReg__centerEl {
  @apply flex justify-end;
}
</style>


